module.exports = __webpack_public_path__ + "img/promote-landing-pages.fc56d7f6.svg";